import dictionary from "configs/dictionary";

import { MenuTopProps } from "../types";
import CtaContent from "components/CtaContent";
import React from "react";

const MenuTop = ({ data }: MenuTopProps) => {
  // TODO: create a type on dictionary
  const ComponentLink = dictionary.ContentfulCtaReferenceV2;

  const { itemList } = data.content[0];

  return (
    <div className="menuTop">
      <ul className="menuTop__list">
        {itemList &&
          itemList.map((item) => {
            return (
              <li className="menuTop__item" key={item.id}>
                {item.pageReference && (
                  <ComponentLink
                    {...item.pageReference}
                    className={`menuTop__link ${item.customClass || ""}`}
                  >
                    <CtaContent {...item.pageReference.content[0]} />
                  </ComponentLink>
                )}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default MenuTop;
